{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "已预约",
      "confirmed": "已确认",
      "completed": "已完成",
      "cancelled": "已取消",
      "no-show": "未到诊",
      "checked-in": "已签到"
    },
    "resultStatus": {
      "final": "最终",
      "preliminary": "初步",
      "corrected": "已更正"
    },
    "allergySeverity": {
      "severe": "严重",
      "high": "高",
      "moderate": "中度"
    },
    "nationalIdType": {
      "NRIC": "NRIC（新加坡身份证）",
      "HKID": "HKID（香港身份证）",
      "MyKad": "MyKad（马来西亚身份证）",
      "Aadhaar": "Aadhaar（印度身份证）",
      "KTP": "KTP（印度尼西亚身份证）",
      "Passport": "护照"
    },
    "messageSenderType": {
      "provider": "医护人员",
      "patient": "患者"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "两次输入的密码不一致",
      "passwordMinLength": "密码至少需要 8 个字符"
    }
  },
  "labels": {
    "abnormal": "异常"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "我的健康",
        "results": "检验结果",
        "appointments": "预约",
        "messages": "消息",
        "forms": "表单"
      },
      "signOut": "退出登录",
      "signOutAria": "退出登录",
      "navAria": "门户导航",
      "footer": "VynaEMR 患者门户 — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "患者门户",
      "labels": {
        "email": "电子邮箱",
        "password": "密码"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "请输入密码"
      },
      "button": {
        "signIn": "登录",
        "signingIn": "登录中..."
      },
      "toast": {
        "welcome": "欢迎回来！",
        "invalid": "电子邮箱或密码不正确"
      },
      "links": {
        "noAccount": "还没有账户？",
        "register": "注册"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "早上好",
        "afternoon": "下午好",
        "evening": "晚上好",
        "fallbackName": "您"
      },
      "subtitle": "以下是您的健康摘要。",
      "error": "无法加载您的健康摘要。请稍后再试。",
      "demographics": {
        "ageLabel": "{{age}} 岁",
        "bloodTypeLabel": "血型：{{bloodType}}"
      },
      "quickLinks": {
        "results": "检验结果",
        "appointments": "预约",
        "messages": "消息",
        "forms": "表单"
      },
      "sections": {
        "allergies": "过敏",
        "activeMedications": "当前用药",
        "activeProblems": "当前健康问题",
        "upcomingAppointments": "即将到来的预约",
        "recentResults": "最近的结果",
        "immunizations": "疫苗接种记录",
        "emergencyContact": "紧急联系人"
      },
      "states": {
        "noAllergies": "没有记录在案的过敏。",
        "noMedications": "没有当前用药。",
        "noAppointments": "没有即将到来的预约。",
        "noResults": "没有最近的结果。"
      },
      "moreCount": "另有 {{count}} 条",
      "sinceDate": "自 {{date}} 起",
      "doseNumber": "第 {{number}} 剂",
      "viewAll": "查看全部",
      "providerTBD": "医生待定"
    },
    "register": {
      "subtitle": "创建您的账户",
      "labels": {
        "fullName": "姓名",
        "email": "电子邮箱",
        "dateOfBirth": "出生日期",
        "phone": "电话",
        "mrn": "MRN（病案号）",
        "idType": "证件类型",
        "idNumber": "证件号码",
        "password": "密码",
        "confirmPassword": "确认密码"
      },
      "placeholders": {
        "fullName": "请输入您的姓名",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "请输入您的证件号码",
        "password": "至少 8 个字符",
        "confirmPassword": "请再次输入密码",
        "selectIdType": "请选择..."
      },
      "mrnHint": "若要将账户关联到您的病历，请提供您的 MRN 或国民身份证号码。",
      "button": {
        "createAccount": "创建账户",
        "creatingAccount": "正在创建账户..."
      },
      "toast": {
        "success": "注册成功，请登录。",
        "failure": "注册失败，请重试。"
      },
      "links": {
        "haveAccount": "已有账户？",
        "signIn": "登录"
      },
      "aria": {
        "dateOfBirth": "出生日期"
      }
    },
    "appointments": {
      "title": "预约",
      "subtitle": "查看和管理您的预约",
      "error": "无法加载预约，请稍后再试。",
      "sections": {
        "upcoming": "即将到来",
        "past": "过往"
      },
      "states": {
        "noUpcoming": "暂无即将到来的预约。",
        "noPast": "暂无过往预约。"
      },
      "reasonLabel": "原因：{{reason}}",
      "instructionsLabel": "注意事项：{{instructions}}",
      "durationMinutes": "{{minutes}} 分钟",
      "actions": {
        "cancel": "取消",
        "confirmCancel": "确认",
        "cancelling": "正在取消...",
        "keep": "保留"
      },
      "toast": {
        "cancelSubmitted": "已提交取消请求，您的医疗团队将与您确认。",
        "cancelFailed": "取消预约失败，请致电诊室。"
      }
    },
    "results": {
      "title": "我的报告",
      "subtitle": "查看您的检验和影像报告",
      "error": "无法加载报告，请稍后再试。",
      "referenceRange": "(参考值：{{range}})",
      "states": {
        "noResults": "暂无报告。"
      }
    },
    "messages": {
      "title": "消息",
      "subtitle": "与您的医疗团队沟通",
      "error": "无法加载消息，请稍后再试。",
      "fromSender": "来自 {{name}}",
      "labels": {
        "subject": "主题",
        "message": "消息内容",
        "reply": "回复"
      },
      "placeholders": {
        "subject": "消息主题",
        "message": "请输入您的消息...",
        "reply": "请输入您的回复..."
      },
      "actions": {
        "newMessage": "新消息",
        "back": "返回消息列表",
        "sendMessage": "发送消息",
        "sendReply": "发送回复",
        "sending": "正在发送..."
      },
      "states": {
        "noMessages": "暂无消息。"
      },
      "thread": {
        "fromSenderWithType": "来自 {{name}}（{{type}}）"
      },
      "compose": {
        "title": "新消息",
        "subtitle": "您的消息将发送给您的医疗团队。"
      },
      "toast": {
        "sent": "消息已发送",
        "sendFailed": "消息发送失败"
      }
    },
    "forms": {
      "title": "表单",
      "subtitle": "填写必要的表单和问卷",
      "error": "无法加载表单，请稍后再试。",
      "sections": {
        "pending": "待填写",
        "completed": "已完成"
      },
      "labels": {
        "required": "必填"
      },
      "placeholders": {
        "select": "请选择……"
      },
      "actions": {
        "fillOut": "填写",
        "back": "返回表单列表",
        "submit": "提交表单",
        "submitting": "提交中……"
      },
      "states": {
        "noPending": "暂无待填写的表单。",
        "noCompleted": "暂无已完成的表单。",
        "noFields": "此表单没有需要填写的字段。"
      },
      "toast": {
        "submitted": "表单已成功提交",
        "submitFailed": "表单提交失败"
      }
    }
  }
}
